import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { services, formations } from "../data/mockData";

export const PageIntrouvable = () => (
  <section className="section px-6 pt-32 lg:pt-40">
    <div className="shell max-w-[840px]">
      <h1 className="font-display text-vt-h2 font-extrabold leading-[1.12] text-brand">
        Cette page n'existe pas
      </h1>
      <p className="lede mt-6">
        L'adresse est peut-être incomplète, ou la page a été déplacée. Voici
        les pages du site.
      </p>

      <div className="mt-9 flex flex-wrap gap-4">
        <Link to="/" className="btn-accent">
          Retour à l'accueil
          <ArrowRight className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" />
        </Link>
        <Link to="/#contact" className="btn-outline">
          Nous écrire
        </Link>
      </div>

      <div className="mt-10 lg:mt-12 grid gap-10 sm:grid-cols-2">
        <div>
          <h2 className="text-vt-h3 font-extrabold text-brand">Services</h2>
          <ul className="mt-4 space-y-3">
            {services.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="font-semibold text-brand">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="text-vt-h3 font-extrabold text-brand">Formations</h2>
          <ul className="mt-4 space-y-3">
            {formations.map((f) => (
              <li key={f.slug}>
                <Link to={`/formations/${f.slug}`} className="font-semibold text-brand">
                  {f.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
